import React, { useEffect } from "react";
import { useState } from "react";
import useApi from "../../hooks/useApi";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Box, CircularProgress } from "@mui/material";

export default () => {
  const [reqType, setReqType] = useState([]);
  const [requests, setRequest] = useState([]);
  const [availability, setAvailability] = useState("");
  const [Loading, setLoading] = useState(false);
  const [requestDetails, setRequestDetails] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [sort, setsort] = useState("");
  const [filter, setfilter] = useState("");
  const [eventTypes, setEventTypes] = useState([]);
  const [allRequests, setAllRequests] = useState([]);

  const requestResponse = useApi((dataToSend) =>
    apiClient.post("/request/request-responses/", dataToSend)
  );

  const handleRequestResponse = async (id, type) => {
    const dataToSend = {
      requestId: id,
      approve_decline: type === "accept" ? true : false,
    };
    const res = await requestResponse.request(dataToSend);

    toast.error(res.data.error);
  };

  const fetch = async () => {
    try {
      initializeApiClient();
      const res = await apiClient.get("/request/request-types/");
      if (res.data.length > 0) {
        setReqType(res.data);
      }
    } catch (error) {
      console.error("Error fetching request types:", error);
      toast.error("An error occurred while fetching request types");
    }
  };
  const fetchRequest = async () => {
    initializeApiClient();
    const res = await apiClient.get("/schedule/event-types/");
    if (res.status === 200) {
      const filteredEventTypes = res.data.filter(
        (type) =>
          !["Campaign Start", "Campaign End"].includes(type.request_type)
      );
      setEventTypes(filteredEventTypes);
    }
  };
  const fetchRequestList = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (sort) params.append("order", sort);

      const urlString = `/request/request-list/?${params?.toString()}`;
      const res = await apiClient.get(urlString);
      if (res.status === 200) {
        setAllRequests(res.data);
        setRequest(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching the request list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequestList();
  }, [sort]);

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    fetchRequest();
  }, []);

  const sortfung = (data) => {
    setsort(data);
  };
  const filterfung = (selectedFilter) => {
    setfilter(selectedFilter);
    if (!selectedFilter) {
      setRequest(allRequests);
    } else {
      const filteredResults = allRequests.filter((request) => {
        if (selectedFilter === "Installation" || selectedFilter === "Install") {
          return (
            request.request_type === "Installation" ||
            request.request_type === "Install"
          );
        }
        return request.request_type === selectedFilter;
      });
      setRequest(filteredResults);
    }
  };

  return (
    <div className=" zoom">
      <div className="site-content h-100">
        <div className="p-1">
          <div className="site-content-body">
            <div className="position-relative">
              {/*-----------Start || Payment section---------*/}
              <section className="req-sec main-sec border py-3">
                <div className="container">
                  <form>
                    {/* ----------Request textarea--------- */}
                    <div className="row " style={{ cursor: "pointer" }}>
                      <Box className="col-md-2 col-6 mt-1 list-group">
                        <div className="dropdown " style={{ width: "120px" }}>
                          <button
                            className="w-100 btn dropdown-toggle fw-bold w-50 text-center list-group-item-action active"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              backgroundColor: "white",
                              color: "#015A96",
                              borderRadius: "15px",
                            }}
                          >
                            Sort
                          </button>
                          <ul
                            className="dropdown-menu p-2 fw-bold"
                            style={{ color: "#015A96" }}
                          >
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={() => sortfung("newest")}
                            >
                              Newest
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={() => sortfung("oldest")}
                            >
                              Oldest
                            </li>
                          </ul>
                        </div>
                      </Box>
                      <Box
                        sx={{ display: { sm: "inline-block", xs: "none" } }}
                        className="col-sm-8 mt-1"
                      >
                        <h5
                          className="col-lg-8 m-0 mt-auto mb-1 mx-auto text-center"
                          style={{ color: "#015A96" }}
                        >
                          Current Requests
                        </h5>
                      </Box>

                      <Box className="col-md-2 col-6 mt-1 list-group">
                        <div
                          className="dropdown ms-auto"
                          style={{ width: "120px", position: "relative" }}
                        >
                          <button
                            className="w-100 btn dropdown-toggle fw-bold w-50 text-center list-group-item-action active"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              backgroundColor: "white",
                              color: "#015A96",
                              borderRadius: "15px",
                            }}
                          >
                            Filter
                          </button>
                          <ul
                            className="dropdown-menu p-2 fw-bold"
                            style={{
                              color: "#015A96",
                              right: 0, // Align to right edge of parent
                              left: "auto", // Override default left alignment
                            }}
                          >
                            <button
                              onClick={() => filterfung("")}
                              type="button"
                              className="list-group-item list-group-item-action"
                            >
                              All
                            </button>
                            {eventTypes.map((item) => (
                              <button
                                onClick={() => filterfung(item.request_type)}
                                type="button"
                                className="list-group-item list-group-item-action"
                                key={item.id}
                              >
                                {item.request_type}
                              </button>
                            ))}
                          </ul>
                        </div>
                      </Box>
                    </div>
                    <Box
                      sx={{ display: { sm: "none", xs: "flex" } }}
                      className="justify-centent-center"
                    >
                      <h5
                        className="col-lg-8 m-0 mt-auto mb-1 mx-auto text-center"
                        style={{ color: "#015A96" }}
                      >
                        Current Requests
                      </h5>
                    </Box>
                    <Box
                      sx={{ display: { sm: "none", xs: "block" } }}
                      className="my-hr my-3 mx-auto mt-0 mb-4"
                    />
                    <Box
                      sx={{ display: { sm: "block", xs: "none" } }}
                      className="my-hr my-3 mx-auto mt-0 mb-4"
                    />
                    {/* ----------Request view--------- */}
                    {!Loading ? (
                      <div className="">
                        {requests.map((request, index) => {
                          // const dateTime = `${date}T${time}Z`;

                          const formattedDateTime = new Date(
                            `${request.start_date}T${request.start_time}`
                          ).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          });

                          return (
                            <div
                              className="d-sm-flex make_res mt-4"
                              key={request.id}
                            >
                              <div className="req-field d-flex align-items-center w-100 h-100">
                                <div className="req-btn d-flex align-items-center justify-content-center ps-2 grey-txt gr-btn mb-xl-0 ">
                                  <img
                                    src={
                                      request.icon_url
                                      // reqType?.find(
                                      //   (item). => item.id === request.request_type
                                      // )?.icon_url
                                    }
                                    className="img-fluid"
                                    width="20px"
                                    alt=""
                                  />
                                  <button
                                    onClick={(e) => e.preventDefault()}
                                    className="py-3  grey-txt  "
                                  >
                                    {request.request_type}
                                  </button>
                                </div>

                                <div
                                  className=" d-flex p-1 align-items-center justify-content-between blue-txt w-100 bg-white req-fix"
                                  style={{ cursor: "pointer" }}
                                >
                                  <div
                                    className={`
                                  
                              }`}
                                  >
                                    <p className="blue-txt mb-0 req_font  bs-lh ">
                                      Date/Time: {formattedDateTime}
                                    </p>
                                    <p className="blue-txt mb-0 req_font bs-lh">
                                      Location: {request.address}
                                    </p>
                                    {/* <p
                                className="blue-txt mb-0  bs-lh"
                                style={{ fontSize: "14px" }}
                              >
                                Estimated Earnings: {request.estimated_earnings}
                              </p> */}
                                  </div>
                                  <div className="d-flex flex-column align-items-center justify-content-center ps-2">
                                    <div
                                      className="   d-flex align-items-center req-link  justify-content-between"
                                      style={{ padding: "13px 0 13px 0" }}
                                      onClick={() => {
                                        setModalShow(true);
                                        setRequestDetails(request);
                                      }}
                                    >
                                      <p className="blue-txt text-nowrap  my-auto">
                                        See Details
                                      </p>
                                      <img
                                        src={require("../../assets/img/attach-f.png")}
                                        alt="Doc"
                                        className="p-1  calendar-icon"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="d-md-block d-none">
                                  {request?.request_type == "Other" ? (
                                    <div
                                      className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                      style={{ minWidth: "200px" }}
                                    >
                                      <a
                                        onClick={() =>
                                          handleRequestResponse(
                                            request.id,
                                            "accept"
                                          )
                                        }
                                        href="#"
                                        type="submit"
                                        className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                      >
                                        Accept
                                      </a>
                                      <a
                                        onClick={() =>
                                          handleRequestResponse(
                                            request.id,
                                            "deny"
                                          )
                                        }
                                        href="#"
                                        className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                      >
                                        Deny
                                      </a>
                                    </div>
                                  ) : (
                                    <div
                                      className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                      style={{ minWidth: "200px" }}
                                    >
                                      <a
                                        href="#"
                                        type="submit"
                                        className="d-flex align-items-center justify-content-center blue-txt bg-white w-100"
                                      >
                                        Scheduled
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="d-md-none d-block">
                                {request?.request_type == "Other" ? (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "accept"
                                        )
                                      }
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Accept
                                    </a>
                                    <a
                                      onClick={() =>
                                        handleRequestResponse(
                                          request.id,
                                          "deny"
                                        )
                                      }
                                      href="#"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-50"
                                    >
                                      Deny
                                    </a>
                                  </div>
                                ) : (
                                  <div
                                    className="ms-xl-2 d-flex justify-content-end req-btns mt-2  mt-xl-0 pad"
                                    style={{ minWidth: "200px" }}
                                  >
                                    <a
                                      href="#"
                                      type="submit"
                                      className="d-flex align-items-center justify-content-center blue-txt bg-white w-100"
                                    >
                                      Scheduled
                                    </a>
                                  </div>
                                )}
                              </div>
                              <hr />
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center mt-3">
                        <h1>
                          {" "}
                          <CircularProgress />
                        </h1>
                      </div>
                    )}{" "}
                    <div>
                      {/* modal body  */}
                      <Modal show={show} onHide={handleClose}>
                        <Modal.Body>
                          <h5 className="text-center p-2">
                            Select Date and Time
                          </h5>
                          {/* <RangeDatePicker/> */}
                          <div>
                            <label className="p-2" htmlFor="time">
                              Date&Time
                            </label>
                            <input
                              className="form-control"
                              type="datetime-local"
                              name=""
                              id="time"
                              onChange={(e) => setAvailability(e.target.value)}
                              value={availability}
                            />
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={handleClose}>
                            Close
                          </Button>
                          <Button variant="primary" onClick={handleClose}>
                            Save Changes
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </form>
                </div>
              </section>
              {/*-----------------------------
                                  End || Payment section
                              ----------------------------- */}
            </div>
          </div>
        </div>
      </div>
      <Detail
        data={requestDetails}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

function Detail(props) {
  const formatDateTime = (date, time) => {
    if (!date || !time) return "N/A";
    const dateObj = new Date(`${date}T${time}`);
    return dateObj.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatSingleDateTime = (date, time) => {
    if (!date || !time) return "Not specified";
    return formatDateTime(date, time);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <h5 style={{ color: "#015A96" }}>Details:</h5>
        <p>{props?.data?.description || "No details available"}</p>

        <h5 style={{ color: "#015A96" }}>Location:</h5>
        <p>{props?.data?.address || "Location not specified"}</p>

        <h5 style={{ color: "#015A96" }}>Start Date and Time:</h5>
        <p>
          {formatSingleDateTime(
            props?.data?.start_date,
            props?.data?.start_time
          )}
        </p>

        <h5 style={{ color: "#015A96" }}>End Date and Time:</h5>
        <p>
          {formatSingleDateTime(props?.data?.end_date, props?.data?.end_time)}
        </p>
      </Modal.Body>
    </Modal>
  );
}
